module.exports = __webpack_public_path__ + "img/131ne.33073e48.svg";